/* Protection is a real, optional Shopify line item. Discount eligibility is configured in Shopify Admin. */
(() => {
  'use strict';
  const widgets = [...document.querySelectorAll('[data-shipping-protection]')];
  if (!widgets.length) return;
  const config = widgets[0].dataset;
  const handle = config.protectionHandle;
  const variantId = Number(config.protectionVariant || 0);
  const root = window.Shopify?.routes?.root || '/';
  let cart = null;
  let busy = false;
  const isProtection = item => item.handle === handle || item.product_handle === handle ||
    String(item.url || '').split('/products/')[1]?.split(/[/?#]/)[0] === handle ||
    (variantId > 0 && Number(item.variant_id) === variantId);
  const request = async (path, body) => {
    const response = await fetch(`${root}${path}`, {
      method: body ? 'POST' : 'GET',
      headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Could not update shipping protection. Please try again.');
    return data;
  };
  const render = nextCart => {
    if (!nextCart?.items) return;
    cart = nextCart;
    const lines = cart.items.filter(isProtection);
    const hasMerchandise = cart.items.some(item => !isProtection(item));
    const selected = lines.length > 0;
    const price = selected ? lines.reduce((sum, line) => sum + Number(line.final_line_price || 0), 0) : Number(config.protectionPrice || 0);
    const currency = typeof cart.currency === 'string' ? cart.currency : cart.currency?.iso_code || 'GBP';
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency });
    widgets.forEach(widget => {
      widget.hidden = !hasMerchandise;
      widget.classList.toggle('is-selected', selected);
      const toggle = widget.querySelector('[data-protection-toggle]');
      toggle.setAttribute('aria-checked', String(selected));
      toggle.disabled = busy || !hasMerchandise || (!selected && (!variantId || config.protectionAvailable !== 'true'));
      widget.querySelector('[data-protection-price]').textContent = selected || variantId ? `+${money.format(price / 100)}` : '';
      widget.querySelector('[data-protection-note]').textContent = selected ? 'Added to your total' :
        variantId && config.protectionAvailable === 'true' ? 'Optional add-on to your order' : 'Currently unavailable';
    });
  };
  // Keep a single add-on per order and remove it when the last merchandise item is removed.
  const normalize = async nextCart => {
    const lines = nextCart.items.filter(isProtection);
    const hasMerchandise = nextCart.items.some(item => !isProtection(item));
    const updates = {};
    lines.forEach((line, index) => {
      const quantity = hasMerchandise && index === 0 ? 1 : 0;
      if (Number(line.quantity) !== quantity) updates[line.key] = quantity;
    });
    return Object.keys(updates).length ? request('cart/update.js', { updates }) : nextCart;
  };
  window.eviraShippingProtection = { normalize, isProtection };
  window.addEventListener('evira:cart:render', event => render(event.detail?.cart));
  document.addEventListener('click', async event => {
    const toggle = event.target.closest('[data-protection-toggle]');
    if (!toggle || busy) return;
    busy = true;
    widgets.forEach(widget => { widget.querySelector('[data-protection-error]').hidden = true; });
    if (cart) render(cart);
    try {
      const current = await request('cart.js');
      const lines = current.items.filter(isProtection);
      if (lines.length) {
        await request('cart/update.js', { updates: Object.fromEntries(lines.map(line => [line.key, 0])) });
      } else if (variantId && current.items.some(item => !isProtection(item))) {
        await request('cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
      }
      const updated = await normalize(await request('cart.js'));
      if (toggle.closest('[data-cart-page]')) {
        window.location.reload();
      } else {
        window.eviraCartDrawer?.render(updated);
      }
      render(updated);
    } catch (error) {
      try {
        const latest = await request('cart.js');
        window.eviraCartDrawer?.render(latest);
        render(latest);
      } catch (_) {}
      widgets.forEach(widget => {
        const notice = widget.querySelector('[data-protection-error]');
        notice.textContent = error.message;
        notice.hidden = false;
      });
    } finally {
      busy = false;
      if (cart) render(cart);
    }
  });
  // Do not allow checkout to race an in-flight add/remove request.
  document.addEventListener('click', event => {
    if (busy && event.target.closest('.cart-drawer__checkout-button, [name="checkout"]')) event.preventDefault();
  }, true);
  document.addEventListener('submit', event => {
    if (busy && event.submitter?.name === 'checkout') event.preventDefault();
  }, true);
  document.addEventListener('DOMContentLoaded', async () => {
    const initial = document.querySelector('[data-cart-initial]');
    if (!initial) return;
    try {
      const original = JSON.parse(initial.textContent);
      window.eviraCartDrawer?.render(original);
      render(original);
      const updated = await normalize(original);
      if (updated !== original) {
        if (document.querySelector('[data-cart-page]')) window.location.reload();
        else window.eviraCartDrawer?.render(updated);
      }
    } catch (_) { /* A later cart refresh will retry. */ }
  });
})();
